import { PDFLinkService } from 'pdfjs-dist/lib/web/pdf_link_service';
export default PDFLinkService;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-pdf/dist/esm/LinkService.js
// module id = 344
// module chunks = 0